import React from 'react';

import { prepareOptionsForLocationSearch } from "../../src/js/helpers";
import BookingForm from "../SharedComponents/BookingForm";
import Benefits from "../SharedComponents/Benefits";
import Footer from "../SharedComponents/Footer";
import MergedCategories from "../SharedComponents/MergedCategories";
import SvgIcon from "../SharedComponents/Icons";
import TopMenu from "../SharedComponents/TopMenu";
import Breadcrumbs from "../SharedComponents/Breadcrumbs";
import NoCommissionBanner from "../SharedComponents/NoCommissionBanner";
import ContactInfo from "./ContactInfo";
import Description from "./Description";
import DetailsInfo from "./DetailsInfo";
import Gallery from "./Gallery";
import Facilities from "./Facilities";
import SuitableFor from "./SuitableFor";
import Map from "./Map";

import './index.sass';


const DetailView = ({ categories,
                      directionsLink,
                      district,
                      facilities,
                      footer,
                      googleApiKey,
                      labelTag,
                      photos,
                      placeCategory,
                      placeInfo,
                      region,
                      regions,
                      secondaryCategories,
                      showLabel,
                      siteName,
                      staticMapUrl,
                      topMenu }) => {

  const {
    addressLine1,
    coords,
    description,
    email,
    guestCapacityFrom,
    guestCapacityTo,
    id,
    permitsOwnCatering,
    phone,
    postalCode,
    postalName,
    pricePerSeat,
    providerAccountType,
    suitableForKinds,
    title,
    vimeoId,
    websiteUrl,
  } = placeInfo;

  const fullAddress = `${ addressLine1 }, ${ postalCode } ${ postalName }`;
  const showSuitableFor = !!(suitableForKinds && suitableForKinds.length);
  const showMap = coords.latitude && coords.longitude;
  const showContacts = providerAccountType !== 'free';
  const showDetailsInfo = !!(guestCapacityFrom || guestCapacityTo || pricePerSeat);
  const showFacilities = !!(facilities && facilities.length);
  const regionsOptions = prepareOptionsForLocationSearch(regions);


  const breadcrumbs = [
    { label: 'Hjem', path: '/' },
    { label: 'Leje', path: '/leje' },
    { label: region.name, path: region.url },
    { label: district.name, path: district.url },
    { label: addressLine1, path: '' },
  ];


  return (
    <div className="detail-view">
      <TopMenu
        {...topMenu}
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <div className="container detail-view__wrapper">

        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <div className="detail-view__headline-section">
          <h1>{ title }</h1>

          <div className="detail-view__address-wrapper">
            <div className="detail-view__address">
              { fullAddress }
            </div>
            <a href="#detailsMap" className="detail-view__address-link">
              { showMap &&
                <SvgIcon name="map_pin" size={22} />
              }

              <span className="mobile">
                { fullAddress }
              </span>

              { showMap &&
                <span className="desktop">
                  &nbsp;· Se på kort
                </span>
              }
            </a>
          </div>

          <MergedCategories
            classes="mobile"
            mainCategory={placeCategory}
            secondaryCategories={secondaryCategories}
          />

        </div>

        <div className="detail-view__gallery-section">
          <Gallery
            labelTag={labelTag}
            photos={photos}
            showLabel={showLabel}
            vimeoId={vimeoId} />
        </div>

        <div className="detail-view__categories-section">
          <MergedCategories
            mainCategory={placeCategory}
            secondaryCategories={secondaryCategories}
          />
        </div>


        <div className="row">
          <div className="col-12 col-lg-6 col-xl-7">

            { showDetailsInfo &&
              <DetailsInfo
                guestCapacityFrom={guestCapacityFrom}
                guestCapacityTo={guestCapacityTo}
                permitsOwnCatering={permitsOwnCatering}
                pricePerSeat={pricePerSeat}
              />
            }

            { showSuitableFor &&
              <SuitableFor classes="mobile" data={suitableForKinds} />
            }

            { description &&
              <Description description={description} />
            }

            { showSuitableFor &&
              <SuitableFor data={suitableForKinds} />
            }

            { showFacilities &&
              <Facilities facilities={facilities} />
            }

            { showMap &&
              <Map
                address={fullAddress}
                coords={coords}
                directionsLink={directionsLink}
                googleApiKey={googleApiKey}
                staticMapUrl={staticMapUrl}
              />
            }
          </div>


          <div className="col-12 col-lg-6 col-xl-5" >
            <div className="detail-view__form-wrapper">

              <div className="detail-view__no-commission-desktop-wrapper">
                <NoCommissionBanner />
              </div>

              <BookingForm
                email={email}
                id={id}
                placeName={title}
                siteName={siteName}
              />

              { showContacts &&
                <ContactInfo
                  email={email}
                  iconSize={24}
                  phone={phone}
                  placeId={id}
                  websiteUrl={websiteUrl}
                />
              }

              <div className="detail-view__no-commission-mobile-wrapper">
                <NoCommissionBanner />
              </div>

              <Benefits shortened={true} />

            </div>
          </div>
        </div>


      </div>

      <Footer { ...footer } hideContacts={true} />
    </div>
  )
}

export default DetailView;
